module.exports = "/assets/data/fc8941487ee76f76ffb31f69958dd33c-GL4.data.json";